import { FC } from 'react'

import { HomeHeroSection as Section } from './HomeHeroSection'

export const HomeHeroSection: FC = () => <Section />

const Resolved = HomeHeroSection

export { Resolved as default }
